import React, { useEffect, useState } from 'react';
import BaseModal from '../../general/BaseModal';
import PropTypes from 'prop-types';
import SelectPaymentMethod from './components/SelectPaymentMethod';
import NotifyBy from '../../../components/account/NotifyBy';
import SelectAddress from './components/SelectAddress';
import Success from './components/Success';
import ADRPaymentMethodsForm from '../../../records/customer/ADRPaymentMethodsForm';
import ReimbursementService from '../../../../src/services/ReimbursementService';
import t from '../../../lib/I18n';
import BAlert, { bAlertType } from '../../../../src/components/general/BAlert';
import PushNotificationActions from '../../../actions/PushNotificationActions';
import DelayRepayActions from '../../../actions/DelayRepayActions';
import _ from 'lodash';
import Col from 'react-bootstrap/lib/Col';
import fpUtils from '../../../../src/utils/fp-utils';
import Button from 'react-bootstrap/lib/Button';
import ADRSubscribeFormRecord from '../../../records/ADRSubscribe/Form';
import CustomerActions from '../../../actions/CustomerActions';
import Address from '../../../records/customer/Address';
import TrackingActions from "../../../actions/TrackingActions";
import useRouter, {useLocation} from '../../../helpers/useRouter';
import urls from '../../../urls';
import { AccountPages } from '../../../constants/AppConstants';
import { oneClickDelayRepayReimbursementMethods } from '../../../constants/AppConstants';


const STEPS_AMOUNT = 4;

export const SubscribeDelayRepay = ({
    handleClose,
    modalOpen,
    user,
    shouldRedirectToAccountScreen,
    setIsJourneyCardModalOpen = _.noop,
    preferenceCentre,
    optedInFrom,
    paymentConfirmation,
    isTabletWidth,
    ...props
}) => {
    const [step, setStep] = useState(0);
    const [notifyByPreference, setNotifyByPreference] = useState(null);
    const [isBankDetailsVerified, setIsBankDetailsVerified] = useState(true);
    const [hasPushNotifications, setHasPushNotifications] = useState(false);

    const isLoggedIn = user && user.isLoggedIn();

    const addresses = isLoggedIn && user.customer.addresses;

    const router = useRouter();
    const location = useLocation();

    const initialForm = new ADRPaymentMethodsForm({
        accountNumber: "",
        amazonCustomerId: null,
        amazonEmail: "",
        charity: null,
        method: null,
        paypalEmail: "",
        sortCode: "",
    });

    const [form, handleFormChange] = useState(initialForm);

    const initialAddressForm = new ADRSubscribeFormRecord({
        country: 'GBR'
    });

    const [addressForm, setAddressForm] = useState(initialAddressForm);
    const [addNewAddress, setAddNewAddress] = useState(false);

    const [showPaymentForm, setShowPaymentForm] = useState(true);

    const [paymentInfo, setPaymentInfo] = useState([]);
    const [hasReimbursementErrors, setHasReimbursementErrors] = useState(false);

    const [selectedAddress, setSelectedAddress] = useState();

    const handleIsValidBACS = async (sortCode, accountNumber) => {
        fpUtils.isValidBACS(sortCode, accountNumber, setIsBankDetailsVerified);
    };

    const resetPaymentInfo = () => {
        setPaymentInfo([]);
    };

    const onSubmitPaymentInfo = async () => {
        const paymentInfoFields = {...form.toJS()};

        let setReimbursementSuccess = false;

        setReimbursementSuccess = await ReimbursementService.setReimbursement(user.id, paymentInfoFields);

        if (setReimbursementSuccess) {
            setPaymentInfo([...paymentInfo, paymentInfoFields]);
            setHasReimbursementErrors(false);
        } else {
            setHasReimbursementErrors(true);
        }

        return setReimbursementSuccess;
    };

    const closeModal = async () => {
        if (preferenceCentre && step === 3) {
            await DelayRepayActions.subscribe(user, notifyByPreference);
        }
        handleClose();
        setNotifyByPreference(null);
        resetPaymentInfo();
        setShowPaymentForm(true);
        setStep(0);
        setIsBankDetailsVerified(true);
        setHasReimbursementErrors(false);
    };

    const onChange = (field, val) => {
        setAddressForm((prevState) => prevState.set(field, val));
    };

    const handleContinue = async () => {
        let paymentInfoSet = false;
        if (step === 0) {
            TrackingActions.selectNotificationPreference(notifyByPreference === 'appAndEmail' ? 'app-and-email' : notifyByPreference);
        }

        if (STEPS_AMOUNT > step + 1) {
            if (step === 1) {
                TrackingActions.selectRepaymentMethod(form.method === oneClickDelayRepayReimbursementMethods.BACS ? 'BACS' : form.method === oneClickDelayRepayReimbursementMethods.PAYPAL ? 'PayPal' : form.method === oneClickDelayRepayReimbursementMethods.CHARITY ? 'charity' : 'eVoucher');
                paymentInfoSet = await onSubmitPaymentInfo();
            }
            if (step === 2) {
                try {
                    if (addNewAddress) {
                        let address = new Address({
                            contactName: `${user.title} ${user.firstNames} ${user.surname}`,
                            line1: addressForm.addressLine1,
                            line2: addressForm.addressLine2,
                            line3: addressForm.addressLine3,
                            town: addressForm.townCity,
                            postCode: addressForm.postcode,
                            country: addressForm.country,
                        });
                        if (address.isComplete()) {
                            await CustomerActions.createAddress(user, address, true);
                        } else {
                            address = addresses.find(x => x.id === selectedAddress);
                            await CustomerActions.updateAddress(user, address, true);
                        }
                    } else {
                        const address = addresses.find(x => x.id === selectedAddress);
                        await CustomerActions.updateAddress(user, address, true);
                    }
                    if (!preferenceCentre) {
                        await DelayRepayActions.subscribe(user, notifyByPreference);
                    }
                    TrackingActions.userOptedIn(optedInFrom);
                    setStep(step + 1);
                } catch (e) {
                    console.warn('error subscribing user to OCDR', e);
                }
            } else {
                if (step === 1) {
                    if (paymentInfoSet) {
                        setStep(step + 1);
                    }
                } else {
                    setStep(step + 1);
                }
            }
        } else {
            setStep(0);
            handleClose();

            if (shouldRedirectToAccountScreen) {
                let query = {
                    shouldOpenAddJourneyModal: true,
                };
                router.push(urls.location(AccountPages.ONE_CLICK_DELAY_REPAY, {}, query));
            } else {
                setIsJourneyCardModalOpen(true);
            }


        }
        if (preferenceCentre && step === 3) {
            await DelayRepayActions.subscribe(user, notifyByPreference);
            router.push(urls.location(AccountPages.ONE_CLICK_DELAY_REPAY, {}, {accountPreferenceCentre: true}));
        }
    };

    const BackButton = (
        <Button
            className="back-button margin-left--xs margin-top--0"
            onClick={() => setStep(step - 1)}
        >
            &#10094;
            <span className="back-button-text">{t(`auto-dr.subscribe.back`)}</span>
        </Button>
    );

    const paymentSection = () => {
        switch (step) {
            case 0:
                return (
                    <NotifyBy
                        notifyByPreference={notifyByPreference}
                        setNotifyByPreference={setNotifyByPreference}
                        hasPushNotifications={hasPushNotifications}
                    />
                );
            case 1:
                return (
                    <React.Fragment>
                        {BackButton}
                        <SelectPaymentMethod
                            form={form}
                            handleFormChange={handleFormChange}
                            showPaymentForm={showPaymentForm}
                            setShowPaymentForm={setShowPaymentForm}
                            paymentInfo={paymentInfo}
                            isValidBACS={handleIsValidBACS}
                        />
                    </React.Fragment>
                );
            case 2:
                return (
                    <React.Fragment>
                        {BackButton}
                        <SelectAddress
                            addresses={addresses}
                            addressForm={addressForm}
                            setAddressForm={setAddressForm}
                            addNewAddress={addNewAddress}
                            selectedAddress={selectedAddress}
                            setSelectedAddress={setSelectedAddress}
                            setAddNewAddress={setAddNewAddress}
                            onChange={onChange}
                            user={user}
                        />
                    </React.Fragment>);
            case 3:
                return <Success />;
            default:
                return null;
        }
    };

    const disableContinue =
        (step === 1 && ((showPaymentForm && !form.isComplete()) || !form.method || !isBankDetailsVerified)) || (form.method === oneClickDelayRepayReimbursementMethods.CHARITY && !form.charity) ||
        (step === 2 && ((!addNewAddress && !selectedAddress) || (addNewAddress && (typeof (selectedAddress) !== 'number') && !addressForm.isComplete())));

    useEffect(() => {
        async function fetchUserPushNotificationPreferences() {
            const preferences = await PushNotificationActions.getPreference(user);
            if (preferences) {
                setHasPushNotifications(preferences.length > 0);
            }
        }

        if (location.query.paymentConfirmation || location.query.accountPreferenceCentre) {
            setIsJourneyCardModalOpen(true);
        }

        if (isLoggedIn) {
            _.defer(() => fetchUserPushNotificationPreferences());
            _.defer(CustomerActions.loadAddresses, user);
        }
    // eslint-disable-next-line
    }, []);

    let successText = t('auto-dr.subscribe.continue');

    if (paymentConfirmation && step === 3 && isTabletWidth) {
        successText = t('auto-dr.subscribe.modal-close');
    } else if (step === 3 && !paymentConfirmation) {
        successText = t('auto-dr.subscribe.add-journey');
    }

    return (
        <BaseModal
            {...props}
            className="modal--med"
            show={modalOpen}
            onClose={closeModal}
            disableContinue={disableContinue}
            onContinue={handleContinue}
            closeText="auto-dr.subscribe.modal-close"
            titleText="auto-dr.subscribe.modal-title"
            hideHeader={step === 3}
            continueText={successText}
            hideContinue={paymentConfirmation && step === 3 && !isTabletWidth}
        >
            <section className="text-left">{paymentSection()}</section>

            {!isBankDetailsVerified && form.method === "bacs" &&
                <Col xs={ 12 } className="margin-bottom--sm">
                    <BAlert type={ bAlertType.DANGER }>{t(`auto-dr.subscribe.bacs-error`)}</BAlert>
                </Col>}

            {hasReimbursementErrors &&
                <Col xs={ 12 } className="margin-bottom--sm">
                    <BAlert type={ bAlertType.DANGER }>{t('auto-dr.account.repayment.method.error')}</BAlert>
                </Col>}
        </BaseModal>
    );
};

SubscribeDelayRepay.propTypes = {
    handleClose: PropTypes.func,
    setIsJourneyCardModalOpen: PropTypes.func,
    modalOpen: PropTypes.bool,
    user: PropTypes.obj,
    optedInFrom: PropTypes.string,
    shouldRedirectToAccountScreen: PropTypes.bool,
    preferenceCentre: PropTypes.bool,
    paymentConfirmation: PropTypes.bool,
    isTabletWidth: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/account/subscribeDelayRepay/index.js